import { AttentionCard, InfoCard, type InfoCardProps } from '@/components/InfoCard/InfoCard'
import { PriceIntentNotificationType } from '@/services/graphql/generated'

type Props = { type: PriceIntentNotificationType } & InfoCardProps

export function PriceIntentNotification({ type, ...forwardedProps }: Props) {
  switch (type) {
    case PriceIntentNotificationType.Warning:
      return <AttentionCard {...forwardedProps} />
    case PriceIntentNotificationType.Info:
    case PriceIntentNotificationType.Notice:
      return <InfoCard {...forwardedProps} />
    default:
      console.warn(`Unknown price intent notification type: ${type}`)
      return null
  }
}
